/*
  SalonID — ontwerp op de samples, in de winkelwagen (okt 2026;
  PLAN-SAMPLES-EIGEN-ONTWERP.md).

  Houdt twee dingen gelijk met de samplebox-regels die een ontwerpkeuze
  hebben (property "_ontwerp"):
  - de toeslag (SKU SAMPLE-EIGEN): één per box met _ontwerp = eigen (een
    regel met aantal 2 telt twee keer); een losse toeslag verdwijnt;
  - het winkelwagenkenmerk "Samplebox ontwerp": "eigen" als er een box met
    eigen ontwerp in zit, "salonid" als alle boxen met een keuze het
    SalonID-ontwerp hebben, en geen kenmerk zonder boxen met een keuze (dan
    werkt productie zoals altijd).

  Draait na elke wijziging in de winkelwagen (cart:update), na het laden
  als cart-items een box met keuze of een toeslag ziet (data-check op de
  scripttag), en vanuit de samplebox na het toevoegen
  (window.SidSampleDesign.sync).
*/
(function () {
  if (window.SidSampleDesign) return;

  var SKU = 'SAMPLE-EIGEN';
  var ATTRIBUTE = 'Samplebox ontwerp';
  var FEE_PRODUCT = '/products/eigen-ontwerp-sample-box.js';
  var routes = window.routes || {};
  var running = null;
  var again = false;

  function request(url, body) {
    var init = { headers: { Accept: 'application/json' } };
    if (body) {
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return fetch(url, init).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw new Error(data.description || data.message || String(response.status));
        return data;
      });
    });
  }

  function look(cart) {
    var state = { own: 0, chosen: 0, fees: [] };
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (p._samplebox && p._ontwerp) {
        state.chosen += item.quantity;
        if (p._ontwerp === 'eigen') state.own += item.quantity;
      }
      if (item.sku === SKU) state.fees.push(item);
    });
    return state;
  }

  function render(data) {
    if (!data.sections || !data.sections['main-cart']) return;
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.updateCartSections === 'function') {
      cartItems.updateCartSections(new DOMParser().parseFromString(data.sections['main-cart'], 'text/html'));
    }
    var detail = Object.assign({}, data, { sidSampleDesign: true });
    document.dispatchEvent(new CustomEvent('cart:update', { detail: detail }));
  }

  // Eén ronde: winkelwagen lezen, zo nodig de toeslag en het kenmerk rechtzetten.
  function once(options, added) {
    var root = routes.cart_url || '/cart';
    return request(root + '.js').then(function (cart) {
      var state = look(cart);

      // Box met eigen ontwerp zonder toeslag (zou niet moeten, de samplebox stuurt ze samen): toevoegen.
      if (state.own > 0 && state.fees.length === 0 && !added) {
        return request(FEE_PRODUCT).then(function (product) {
          var variant = product.variants && product.variants[0];
          if (!variant) return false;
          return request((routes.cart_add_url || '/cart/add') + '.js', { items: [{ id: variant.id, quantity: state.own }] })
            .then(function () { return once(options, true); });
        });
      }

      var updates = {};
      var changed = false;
      state.fees.forEach(function (item, i) {
        var want = i === 0 ? state.own : 0;
        if (item.quantity !== want) {
          updates[item.key] = want;
          changed = true;
        }
      });

      var attributes = {};
      var want = state.own > 0 ? 'eigen' : (state.chosen > 0 ? 'salonid' : '');
      var have = (cart.attributes && cart.attributes[ATTRIBUTE]) || '';
      if (want !== have) {
        attributes[ATTRIBUTE] = want;
        changed = true;
      }

      if (!changed) return false;
      var body = { updates: updates, attributes: attributes };
      if (options.render) {
        body.sections = 'main-cart';
        body.sections_url = window.location.pathname;
      }
      return request(routes.cart_update_url || '/cart/update', body).then(function (data) {
        if (options.render) render(data);
        return true;
      });
    });
  }

  /*
    sync({ render: false }) vanuit de samplebox: die laat de lade daarna zelf
    zien (ajaxProduct:added). Anders ververst sync de winkelwagen als er iets
    veranderde. Gelijktijdige aanroepen worden één extra ronde.
  */
  function sync(options) {
    options = Object.assign({ render: true }, options || {});
    if (running) {
      again = true;
      return running;
    }
    running = once(options)
      .catch(function (error) {
        if (window.console) console.warn('[SidSampleDesign]', error);
        return false;
      })
      .then(function (changed) {
        running = null;
        if (again) {
          again = false;
          return sync(options);
        }
        return changed;
      });
    return running;
  }

  window.SidSampleDesign = { sync: sync };

  document.addEventListener('cart:update', function (event) {
    if (event.detail && event.detail.sidSampleDesign) return;
    sync();
  });

  function boot() {
    if (document.querySelector('script[data-sid-sample-design-check]')) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
